import { defineStore } from "pinia";
import { PageState, usePageStore } from "@rmp/core/stores/composables/page/usePageStore";
import AbortService from "@rmp/core/services/abortService";
import { BaseStepState } from "@rmp/id/stores/masterAccountAccess/steps/shared/baseStepState";
import { MasterAccountApplicationStepOrdersEnum } from "@rmp/id/stores/masterAccountAccess/types/MasterAccountApplicationStepOrdersEnum";

const abortService = new AbortService();

const page = usePageStore(abortService);

export interface MasterAccountAccessSignApplicationStepState extends BaseStepState, PageState {
	encodedDetachedSignatureString: string;
	encodedApplicationString: string;
}

const getDefaultState = (): MasterAccountAccessSignApplicationStepState => {
	return {
		...page.getDefaultPageState(),
		encodedDetachedSignatureString: "",
		encodedApplicationString: "",
		order: MasterAccountApplicationStepOrdersEnum.SIGN_APPLICATION_STEP_ORDER
	};
};

export const useMasterAccountAccessSignApplicationStepStore = defineStore({
	id: "master-account-access-sign-application-step",
	state: (): MasterAccountAccessSignApplicationStepState => getDefaultState(),
	getters: {
		...page.getters,
		stepCompleted(state: MasterAccountAccessSignApplicationStepState): boolean {
			return this.signed;
		},
		signed(state: MasterAccountAccessSignApplicationStepState): boolean {
			return !!state.encodedApplicationString && !!state.encodedDetachedSignatureString;
		}
	},
	actions: {
		...page.actions,
		async beforeInitialized() {
		}
	}
});
